import { Currency } from './currency'
import { EntityTypeForRoleManagement } from './role'
import { Multilingual } from './roomtype'

export type PriceActionWithEditMode = {
  error?: boolean
  editing: boolean
  id: string
  priceAction: PriceAction
}

export type PriceClass = {
  id?: string
  code?: string
  name: string
  nameTranslatedList: Multilingual[]
  archivedAt?: string
  priceActions: PriceAction[]
  inputCurrency: Currency
  outputCurrency: Currency
}

export type PriceAction = {
  actionType: ActionType
  actionAmount: ActionAmount
  beneficiary?: Beneficiary
  order: number
  description: string
  descriptionTranslatedList: Multilingual[]
}

export type PriceActionForGenerate = {
  actionType: ActionType
  actionAmount: ActionAmount
  beneficiary?: Beneficiary
  order: number
  description: TypeName
}

export type ActionType =
  | 'CommissionAbsorbed'
  | 'CommissionPassOn'
  | 'Markup'
  | 'Exchange'
  | 'Discount'
  | 'DisplayRate'
  | ''

export const actionTypes: { label: string; value: ActionType }[] = [
  { label: 'Absorbed Commission', value: 'CommissionAbsorbed' },
  { label: 'Pass-On Commission', value: 'CommissionPassOn' },
  { label: 'Markup', value: 'Markup' },
  { label: 'Exchange', value: 'Exchange' },
  { label: 'Discount', value: 'Discount' },
  { label: 'Display Rate', value: 'DisplayRate' }
]

export type ActionAmount = {
  amount?: number
  type?: ActionAmountType
  fromCurrency: Currency
  toCurrency: Currency
  direction?: ActionAmountDirection
}

export type ActionAmountType = 'Percent' | 'FixedFee' | '' | undefined
export type ActionAmountDirection = 'Increase' | 'Decrease' | '' | undefined

export type Beneficiary = {
  entityType: string
  entityID: string
  entityCode: string
  entityName: string
}

export interface TypeName {
  FA: string
  EN: string
}

export interface EntityAndWalletType {
  entityType: EntityTypeForRoleManagement
  walletType: string
}
